// Generated by purs version 0.15.15
import * as $foreign from "./foreign.js";

export {
    createRoot,
    hydrateRoot,
    renderRoot,
    unmountRoot
} from "./foreign.js";
//# sourceMappingURL=index.js.map
